import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout';
import { Home, WebDevelopmentProcess, Portfolio, Blogs, BlogDetail, Pricing, Contact, FullStackExpert, Reviews, WhoWeAre, Faq, Disclaimer, TermsConditions, PrivacyPolicy } from './pages';
import WebDevelopment from './pages/services/WebDevelopment';
import WebApplication from './pages/services/WebApplicationDevelopment';
import MobileApps from './pages/services/MobileAppDevelopment';
import UIUXDesign from './pages/services/UIUXDesign';
import EcommerceSolutions from './pages/services/EcommerceSolutions';
import DigitalMarketing from './pages/services/DigitalMarketing';
import CloudSolutions from './pages/services/CloudSolutions';
import DevOps from './pages/services/DevOps';
import Resume from './pages/resume';
import './App.scss';
import AdminRoutes from './admin/AdminRoutes';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Admin panel routes (no Layout) */}
        <Route path="/admin/*" element={<AdminRoutes />} />
        
        {/* Resume Page (no Layout) */}
        <Route path="/resume" element={<Resume />} />
        
        {/* Main site routes */}
        <Route
          path="*"
          element={
            <div className="App">
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/who-we-are" element={<WhoWeAre />} />
                  <Route path="/development-process" element={<WebDevelopmentProcess />} />
                  <Route path="/full-stack-expert" element={<FullStackExpert />} />
                  <Route path="/development-reviews" element={<Reviews />} />
                  <Route path="/services/web-development" element={<WebDevelopment />} />
                  <Route path="/services/web-application-development" element={<WebApplication />} />
                  <Route path="/services/mobile-app-development" element={<MobileApps />} />
                  <Route path="/services/ui-ux-design" element={<UIUXDesign />} />
                  <Route path="/services/ecommerce-development" element={<EcommerceSolutions />} />
                  <Route path="/services/digital-marketing" element={<DigitalMarketing />} />
                  <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
                  <Route path="/services/devops" element={<DevOps />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                  <Route path="/blogs" element={<Blogs />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<Faq />} />
                  <Route path="/disclaimer" element={<Disclaimer />} />
                  <Route path="/terms" element={<TermsConditions />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  {/* Add catch-all route for 404 */}
                  <Route path="*" element={<Home />} />
                </Routes>
              </Layout>
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;

